import i18next from 'i18next';
import Pseudo from 'i18next-pseudo';
import i18nextXHRBackend from 'i18next-xhr-backend';
import {initReactI18next} from 'react-i18next';
import {settings} from './services/localConfig/debugPanel';

const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

interface I18nOptions {
  locale: string;
  baseUrl?: string;
  translations?: Record<string, string>;
}

export function createI18nInstance({locale, translations, baseUrl = ''}: I18nOptions): i18next.i18n {
  return i18next
    .createInstance({
      debug: false,
      lng: locale,
      fallbackLng: 'en',
      keySeparator: '~', // disable spiting keys
      interpolation: {
        escapeValue: false,
      },
      postProcess: settings.enablePseudoLocalization ? ['pseudo'] : [],
      ...(translations
        ? {
            resources: {
              [locale]: {
                translation: translations,
              },
            },
          }
        : {}),
      backend: {
        loadPath: `${baseUrl}assets/locale/music-get-window_{{lng}}.json`,
        crossDomain: true,
      },
    })
    .use(
      new Pseudo({
        enabled: settings.enablePseudoLocalization,
        repeatedLetters: alphabet,
        letterMultiplier: settings.pseudoLocalizationMultiplier,
        uglifedLetterObject: settings.enableLocalizationUglify
          ? undefined
          : alphabet.reduce(
              (acc, letter) => ({
                ...acc,
                [letter]: letter,
              }),
              {},
            ),
      }),
    )
    .use(i18nextXHRBackend)
    .use(initReactI18next);
}
